"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getByName = void 0;
// see: https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
function getByName(name, url) {
    if (url === void 0) { url = window.location.href; }
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
exports.getByName = getByName;
